import { createStore } from 'redux'

function serverReducer(state, action)
{
  switch (action.type)
  {
    case 'INIT':
      return {
        data: action.data,
      }
    default:
      return {}
  }
}

let serverStore = createStore(serverReducer)

export default serverStore



// WEBPACK FOOTER //
// ./src/reducers/serverStore.js